import React, { useState } from "react";
import { Autocomplete, DialogContent } from "@mui/material";
import { Button, Dialog, Stack, TextField, Typography } from "@mui/material";
import { ledgerUpdated } from "./ledgerSlice";
import { updateLedger } from "./httpCalls";
import { useDispatch, useSelector } from "react-redux";

function UpdateLedger({ open, onClose, ledger, onUpdate }) {
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.company);

  const [state, setState] = useState({
    loading: false,
    editTitle: ledger.name || "",
    editAddress: ledger.address || "",
    editRegion: ledger.region || "",
  });
  const toggle = () => {
    if (!state.loading) {
      onClose();
    }
  };

  const handleInput = (e) => {
    let { name, value } = e.target;
    setState((pre) => ({ ...pre, [name]: value }));
  };
  const handleRegion = (e, val) => {
    setState((prev) => ({ ...prev, editRegion: val }));
  };
  const searchRegions = () => {
    if (company?.ledgerRegions) {
      return company.ledgerRegions;
    } else {
      return [];
    }
  };
  const handleUpdate = async () => {
    let newLedger = {
      _id: ledger._id,
      _rev: ledger._rev,
      name: state.editTitle,
      address: state.editAddress,
      region: state.editRegion,
    };
    toggle();
    if (ledger.index == "searched") {
      onUpdate(newLedger);
    } else {
      dispatch(ledgerUpdated({ index: ledger.index, ledger: newLedger }));
    }
    await updateLedger(newLedger);
  };

  const isOptionEqualToValue = (option, value) => {
    return option === value || value === "";
  };
  return (
    <Dialog
      title="Update Ledger"
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
      sx={{ padding: "5%" }}
    >
      <DialogContent sx={{ padding: "5%" }}>
        <Stack direction="column" spacing={2}>
          <Typography
            variant="h6"
            sx={{ textAlign: "center", color: "#4EAF51" }}
          >
            Update Ledger
          </Typography>
          <TextField
            autoFocus
            size="small"
            label="Ledger Name"
            fullWidth
            name="editTitle"
            value={state.editTitle}
            onChange={handleInput}
          />
          <TextField
            size="small"
            label="Address"
            type="text"
            name="editAddress"
            fullWidth
            value={state.editAddress}
            onChange={handleInput}
          />
          <Autocomplete
            size="small"
            onChange={(e, val) => {
              handleRegion(e, val);
            }}
            sx={{ background: "white" }}
            isOptionEqualToValue={isOptionEqualToValue}
            getOptionLabel={(option) => option || ""}
            id="controllable-states-demo"
            options={searchRegions()}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Region"
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />

          <Stack direction="row" justifyContent="center" spacing={3}>
            <Button variant="contained" onClick={handleUpdate}>
              Update Ledger
            </Button>
            <Button variant="outlined" onClick={toggle}>
              Cancel
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default UpdateLedger;
